
































import Vue from 'vue'
import { IImagePopup } from '../store/state'

interface CMethods {
  closePopup(): void
  focusOnCloseButton(): void
  focusOnTriggerLink(src: string): void
  visibilityChangeHandler(): void
  escapeButtonHandler(event: KeyboardEvent): void
}

interface CComputed {
  imagePopup: IImagePopup
}

export default Vue.extend<{}, CMethods, CComputed, {}>({
  name: 'ImagePopup',
  mounted() {},
  computed: {
    imagePopup() {
      return this.$store.getters.imagePopup
    }
  },
  watch: {
    imagePopup(value) {
      if (value.hidden === false) {
        this.focusOnCloseButton()
        document.addEventListener('keydown', this.escapeButtonHandler)
      } else document.removeEventListener('keydown', this.escapeButtonHandler)
    }
  },
  methods: {
    closePopup() {
      const theSrc = this.imagePopup.src
      this.$store
        .dispatch({
          type: 'imagePopup',
          payload: { hidden: true }
        })
        .then(() => {
          document.removeEventListener('focusin', this.visibilityChangeHandler)
          this.focusOnTriggerLink(theSrc)
        })
    },
    focusOnCloseButton() {
      const dialogCloseHTMLElement = this.$refs.dialogClose as HTMLElement

      setTimeout(() => {
        document.addEventListener('focusin', this.visibilityChangeHandler)
        if (dialogCloseHTMLElement) dialogCloseHTMLElement.focus()
      }, 100)
    },
    focusOnTriggerLink(src) {
      const link = document.querySelector(`[href='${src}']`) as HTMLLinkElement
      setTimeout(() => {
        if (link) link.focus()
      }, 10)
    },
    visibilityChangeHandler() {
      const activeElement = document.activeElement as HTMLElement
      const dialogWrapper = document.getElementById(
        'dialog-wrapper'
      ) as HTMLElement
      if (!dialogWrapper.contains(activeElement)) this.focusOnCloseButton()
    },
    escapeButtonHandler(event) {
      if (event.key === 'Escape') this.closePopup()
    }
  }
})
